import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useSingleSaleTableListStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            background: '#fff'
        },
        gridHeader: {
            borderBottom: '1px solid #D4D4D4',

            [theme.breakpoints.down('sm')]: {
                display: 'none'
            },
            [theme.breakpoints.up('md')]: {
                paddingBottom: '15px',
                marginBottom: '15px'
            }
        },
        tableList: {
            gap: 24,
            display: 'flex',

            [theme.breakpoints.down('sm')]: {
                flexWrap: 'wrap'
            },
            [theme.breakpoints.up('md')]: {
                paddingBottom: 24,
                flexDirection: 'column'
            }
        },
        gridCenter: {
            display: 'flex',
            justifyContent: 'center'
        },
        row: {
            [theme.breakpoints.down('sm')]: {
                '&:last-child': {
                    marginBottom: 24
                }
            },
            [theme.breakpoints.up('md')]: {
                marginTop: 24
            }
        }
    })
);
